// extracted by mini-css-extract-plugin
module.exports = {"ht-container":"DevlinkSection_ht-container__FSmGD","lg":"DevlinkSection_lg__fpm81","sm":"DevlinkSection_sm__BTHu2","md":"DevlinkSection_md__C3D53"};